export const GET_CUSTOMER_DOMAINS_SUCCESS = 'COLOR_CARD/GET_CUSTOMER_DOMAINS_SUCCESS';
export const GET_CUSTOMER_DOMAINS_FAILURE = 'COLOR_CARD/GET_CUSTOMER_DOMAINS_FAILURE';

export const LIST_SUBSTRATES_SUCCESS = 'COLOR_CARD/LIST_SUBSTRATES_SUCCESS';
export const LIST_SUBSTRATES_FAILURE = 'COLOR_CARD/LIST_SUBSTRATES_FAILURE';

export const LIST_TEMPLATES_SUCCESS = 'COLOR_CARD/LIST_TEMPLATES_SUCCESS';
export const LIST_TEMPLATES_FAILURE = 'COLOR_CARD/LIST_TEMPLATES_FAILURE';

export const SUBMIT_START = 'COLOR_CARD/SUBMIT_START';
export const SUBMIT_ACCEPTED = 'COLOR_CARD/SUBMIT_ACCEPTED';
export const SUBMIT_START_FAILURE = 'COLOR_CARD/SUBMIT_START_FAILURE';
export const SUBMIT_SUCCESS = 'COLOR_CARD/SUBMIT_SUCCESS';
export const SUBMIT_FAILURE = 'COLOR_CARD/SUBMIT_FAILURE';
export const CLEAR_ERROR = 'COLOR_CARD/CLEAR_ERROR';
